import Types from "../../constants/Types.js";
export default {
  name: 'firmwareUpgradeStrategy',
  objectType: Types.deviceType,
  valueType: `${Types.apiName}.firmwareUpgradeStrategy`,
  get: (data, cxt) => {
    return data?.firmwareUpgradeStrategy;
  },
  set: (data, value, cxt) => {
    return {
      ...data,
      firmwareUpgradeStrategy: value
    };
  },
  canSet: () => true,
  getPatch: (data, value, cxt) => {
    return {
      path: 'firmwareUpgradeStrategy',
      value
    };
  },
  displayName: 'Firmware Upgrade Strategy',
  source: {
    type: Types.apiName,
    editable: true,
    creatable: true
  }
};